import { content } from '../data/content';
import { PRODUCT } from '../data/product';
import { BuyButton, SectionHeading } from './ui/Ui';

/**
 * لقطات محادثات حقيقية من زبائن، مرتّبة حسب الاعتراض الذي يهدمه كل ردّ:
 *
 *   1) الخوف على القماش — أول ما يمنع الشراء في أي جهاز حراري
 *   2) هل سيبقى مستعملاً أم يُنسى في الخزانة — اعتراض «صرفت وما استفدت»
 *   3) الندم على التأخير — لا يزيل اعتراضاً بل يخلق إلحاحاً، ولهذا جاء أخيراً
 *      وقبل زر الشراء مباشرة
 *
 * لقطة الشاشة أقوى من نص مكتوب لأن النص يستطيع أي أحد اختلاقه، أما المحادثة
 * فتحمل توقيتها وطريقة كلام صاحبها.
 */
const CHATS = [
  {
    src: '/chat-1.jpg',
    alt: 'محادثة واتساب: زبونة تؤكد أن الجهاز لم يؤثر على قماش الشيفون',
    caption: 'جرّبته على الشيفون… ولا خيط تأثّر',
    icon: 'fa-shield-heart',
  },
  {
    src: '/chat-2.jpg',
    alt: 'محادثة واتساب: زبونة تستخدم الجهاز يومياً ولم تعد تستعمل المكواة العادية',
    caption: 'بتستخدمه كل يوم — ونسيت وين حطّت المكواة القديمة',
    icon: 'fa-repeat',
  },
  {
    src: '/chat-3.jpg',
    alt: 'محادثة واتساب: زبونة تقول إنها نادمة لأنها لم تشتر الجهاز من سنة',
    caption: 'ندمانة إني ما جبته من سنة',
    icon: 'fa-heart',
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="scroll-mt-16 md:scroll-mt-20 py-10 md:py-20 bg-white">
      <div className="container mx-auto">
        <SectionHeading
          eyebrow={content.reviewsEyebrow}
          icon="fa-comments"
          iconColor="text-z-orange"
          title={content.feedbackTitle}
          highlight={content.feedbackTitleHighlight}
        />

        {/* رقم واحد صادق خير من ثلاثة أرقام أحدها مخترع */}
        <p className="flex items-center justify-center gap-2 text-sm text-z-gray mb-8 md:mb-10">
          <i className="fa-solid fa-user-check text-z-green" />
          <span dir="ltr">+{PRODUCT.customersCount}</span> {content.customersLine}
        </p>

        {/*
          تخطيط أعمدة لا شبكة: ارتفاع اللقطات مختلف (703 و783 و657 بكسل)، وفي
          الشبكة تتساوى الصفوف فتترك فراغاً أسفل الأقصر أو تقصّ الأطول. الأعمدة
          تدع كل بطاقة بارتفاعها الطبيعي فتُقرأ الرسائل كاملة بلا قصّ.
        */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-5 max-w-6xl mx-auto">
          {CHATS.map((chat) => (
            <figure
              key={chat.src}
              className="break-inside-avoid mb-4 md:mb-5 bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm"
            >
              <img
                src={chat.src}
                alt={chat.alt}
                loading="lazy"
                className="w-full block"
              />

              <figcaption className="flex items-start gap-3 p-4 border-t border-gray-100">
                <span className="w-8 h-8 shrink-0 rounded-lg bg-z-green/10 text-z-green flex items-center justify-center text-xs">
                  <i className={`fa-solid ${chat.icon}`} />
                </span>
                <p className="text-sm font-bold text-z-navy leading-snug">{chat.caption}</p>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* الشراء هنا لا بعد الأسئلة: هذه أعلى نقطة ثقة في الصفحة كلها */}
        <div className="flex justify-center mt-6 md:mt-8">
          <BuyButton label={content.btnBuyNow} />
        </div>
      </div>
    </section>
  );
}
